import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import generateStaticStrategy from './staticStrategy'
import { pivotThemeDecorator } from './decorator'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'

const generatePivotThemeStrategy = (): WidgetSettingComposingStrategy => {
  const staticStrategy = generateStaticStrategy()
  const decoratedStrategy = pivotThemeDecorator(staticStrategy)

  return {
    ...decoratedStrategy,
    composeDrillDownWidgetSetting: (widgetSetting: DashboardWidgetType, insights: InsightData[]) =>
      decoratedStrategy.composeDrillDownWidgetSetting(widgetSetting, [], insights)
  }
}

export default generatePivotThemeStrategy
